export const state = () => ({
  posts: []
});

export const mutations = {};
